export class AddAssessmentRequest {
  constructor(public reportId: number, public speciesList: number[]) {}
}
